let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3h6fQ")).then(() => parcelRequire('7jOfs'));